export default () => {
  document.body.scrollTop = document.documentElement.scrollTop = 0;
};



// WEBPACK FOOTER //
// ./src/Common/scrollToTopOfPage/index.js